<template>
  <div>
    <div class="grid-x hide-for-print">
      <div class="cell auto" />
      <print-button />
    </div>
    <div class="pega-photo-clip-sp-caution-text">
      ※「インタビュー」「フォトクリップ」は掲載時ご利用の場合のみ表示されます。
    </div>
    <slot />
  </div>
</template>

<script>
import PrintButton from '@/components/atoms/PrintButton'
export default {
  components: {
    PrintButton
  }
}
</script>
